// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable sonarjs/no-duplicate-string */
import { ITaggingEventNodes } from 'common-services/event-config';
import {
  claimsScreen,
  configureProduct,
  crashScreen,
  deductiblesSelection,
  errorPage,
  optionalProduct,
  quotationCompleted,
  quotationConfirmed,
} from './common-config';

export const tngaProductCategory = 'services';
export const tngaProductSubcategory = 'insurance';

const insuranceCalculator = 'insurance-calculator';
export const ucInsuranceCalculator = 'uc-insurance-calculator';
export const scInsuranceCalculator = 'sc-insurance-calculator';

export const tngTaggingEventNC = {
  widgetLoaded: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: configureProduct,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: configureProduct,
    },
  },
  widgetClosed: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'close-calculator',
      label: '$insStepName',
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: '$insStepName',
    },
  },
  nextSuccess: {
    event: {
      name: 'componentevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-next',
      label: '$insStepName',
    },
  },
  nextFail: {
    event: {
      name: 'componentevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'error',
      label: '$insStepName',
    },
  },
  offersLoaded: {
    event: {
      name: 'inscalcevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: quotationCompleted,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '1',
      step: quotationCompleted,
    },
  },
  offersLoadedOfferShort: {
    event: {
      name: 'inscalcevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'quotation-completed-launch-offer',
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '1',
      step: 'quotation-completed-launch-offer',
      variant: 'speedboat-short',
    },
  },
  offersLoadedOfferLong: {
    event: {
      name: 'inscalcevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: quotationCompleted,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '1',
      step: quotationCompleted,
      variant: 'speedboat-long',
    },
  },
  productsLoaded: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: optionalProduct,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: optionalProduct,
    },
  },
  optionProductAdded: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'add-option-$insProductName',
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: 'add-option-$insProductName',
    },
  },
  offerChosen: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: quotationConfirmed,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: quotationConfirmed,
    },
  },
  errorPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: errorPage,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '-1',
      step: errorPage,
    },
  },
  secondFormPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'personal-details',
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: 'personal-details',
      variant: 'speedboat-long',
    },
  },
  errorCrashScreen: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: crashScreen,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '-1',
      step: crashScreen,
    },
  },
  claimsPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: claimsScreen,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: claimsScreen,
    },
  },
  back: {
    event: {
      name: 'componentevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: '$insStepName',
    },
  },
  backClaimsPage: {
    event: {
      name: 'componentevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: claimsScreen,
    },
  },
  offerReadMore: {
    event: {
      name: 'componentevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'view-product-info-$insProductName',
    },
  },
  deductiblesLoaded: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: deductiblesSelection,
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: deductiblesSelection,
    },
  },
  deductibleChosen: {
    event: {
      name: 'workflowevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'select-deductible-$insDeductibleName',
    },
    workflow: {
      name: insuranceCalculator,
      conversion: '0',
      step: 'select-deductible-$insDeductibleName',
    },
  },
  sendEmail: {
    event: {
      name: 'ctaevent',
      componentName: insuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'send-email-$insProductName',
    },
  },
};

export const tngTaggingEventUC: Record<string, ITaggingEventNodes> = {
  widgetLoaded: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: configureProduct,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: configureProduct,
    },
  },
  widgetClosed: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'close-calculator',
      label: '$insStepName',
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: '$insStepName',
    },
  },
  nextSuccess: {
    event: {
      name: 'componentevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-next',
      label: '$insStepName',
    },
  },
  nextFail: {
    event: {
      name: 'componentevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'error',
      label: '$insStepName',
    },
  },
  offersLoaded: {
    event: {
      name: 'inscalcevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: quotationCompleted,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '1',
      step: quotationCompleted,
    },
  },
  productsLoaded: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: optionalProduct,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: optionalProduct,
    },
  },
  optionProductAdded: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'add-option-$insProductName',
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: 'add-option-$insProductName',
    },
  },
  offerChosen: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: quotationConfirmed,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: quotationConfirmed,
    },
  },
  sendEmail: {
    event: {
      name: 'ctaevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'send-email-$insProductName',
    },
  },
  errorPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: errorPage,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '-1',
      step: errorPage,
    },
  },
  errorCrashScreen: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: crashScreen,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '-1',
      step: crashScreen,
    },
  },
  claimsPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: claimsScreen,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: claimsScreen,
    },
  },
  back: {
    event: {
      name: 'componentevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: '$insStepName',
    },
  },
  backClaimsPage: {
    event: {
      name: 'componentevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: claimsScreen,
    },
  },
  offerReadMore: {
    event: {
      name: 'componentevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'view-product-info-$insProductName',
    },
  },
  deductiblesLoaded: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: deductiblesSelection,
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: deductiblesSelection,
    },
  },
  deductibleChosen: {
    event: {
      name: 'workflowevent',
      componentName: ucInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'select-deductible-$insDeductibleName',
    },
    workflow: {
      name: ucInsuranceCalculator,
      conversion: '0',
      step: 'select-deductible-$insDeductibleName',
    },
  },
};

export const tngTaggingEventSC: Record<string, ITaggingEventNodes> = {
  widgetLoaded: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: configureProduct,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: configureProduct,
    },
  },
  widgetClosed: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'close-calculator',
      label: '$insStepName',
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: '$insStepName',
    },
  },
  nextSuccess: {
    event: {
      name: 'componentevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-next',
      label: '$insStepName',
    },
  },
  nextFail: {
    event: {
      name: 'componentevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'error',
      label: '$insStepName',
    },
  },
  offersLoaded: {
    event: {
      name: 'inscalcevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: quotationCompleted,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '1',
      step: quotationCompleted,
    },
  },
  productsLoaded: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: optionalProduct,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: optionalProduct,
    },
  },
  optionProductAdded: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'add-option-$insProductName',
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: 'add-option-$insProductName',
    },
  },
  offerChosen: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: quotationConfirmed,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: quotationConfirmed,
    },
  },
  sendEmail: {
    event: {
      name: 'ctaevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'send-email-$insProductName',
    },
  },
  errorPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: errorPage,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '-1',
      step: errorPage,
    },
  },
  errorCrashScreen: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: crashScreen,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '-1',
      step: crashScreen,
    },
  },
  claimsPageLoaded: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: claimsScreen,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: claimsScreen,
    },
  },
  back: {
    event: {
      name: 'componentevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: '$insStepName',
    },
  },
  backClaimsPage: {
    event: {
      name: 'componentevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'click-back',
      label: claimsScreen,
    },
  },
  offerReadMore: {
    event: {
      name: 'componentevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-action',
      label: 'view-product-info-$insProductName',
    },
  },
  deductiblesLoaded: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: deductiblesSelection,
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: deductiblesSelection,
    },
  },
  deductibleChosen: {
    event: {
      name: 'workflowevent',
      componentName: scInsuranceCalculator,
      componentGroup: 'insurance',
      action: 'ic-workflow',
      label: 'select-deductible-$insDeductibleName',
    },
    workflow: {
      name: scInsuranceCalculator,
      conversion: '0',
      step: 'select-deductible-$insDeductibleName',
    },
  },
};
